import { z } from "zod";
import { useGeneratedForm } from "../../hooks/useGeneratedForm";
import { DynamicForm } from "../../util/DynamicForm";
import API_URL from "../../config/apiConfig";
import MutationHandler from "../../util/MutationHandler";
import { apiPut } from "../../util/axiosUtil";

export default function OwnerRecharge({ onCancel, data, onSuccess }) {
  const formConfig = {
    points: {
      label: "Points",
      type: "number",
      placeholder: "Enter points",
      required: true,
      defaultValue: 0,
      validation: z.preprocess(
        (val) => (val === "" ? 0 : Number(val)),
        z.number().superRefine((value, ctx) => {
          if (Number.isNaN(value)) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: "Points must be a number",
            });
          } else if (value < 1) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: "Points must be at least 1",
            });
          }
        })
      ),
    },
  };

  return (
    <MutationHandler
      mutationFn={(formData) =>
        apiPut(
          `${API_URL}/api/owners/recharge?ownerId=${data.id}&points=${formData.points}`,
          null,
          {
            "Content-Type": "application/json",
          }
        )
      }
      onCancel={onCancel}
      onSuccess={onSuccess}
    >
      {(mutation) => (
        <RechargeOwnerForm
          formConfig={formConfig}
          onSubmit={(value) => mutation.mutate(value)}
          isLoading={mutation.isPending}
          onCancel={onCancel}
        />
      )}
    </MutationHandler>
  );
}

function RechargeOwnerForm({ formConfig, onSubmit, isLoading, onCancel }) {
  const form = useGeneratedForm(formConfig, async ({ value }) => {
    onSubmit(value);
  });

  return (
    <DynamicForm
      form={form}
      formConfig={formConfig}
      isLoading={isLoading}
      onCancel={onCancel}
      buttonText={"Recharge"}
    />
  );
}
